import React from 'react';
import { Link } from 'react-router-dom';

const CompanyRequiredPage: React.FC = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md w-full text-center px-4">
                <div className="bg-white rounded-lg shadow-md p-8">
                    <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                        <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>
                    
                    <h1 className="text-2xl font-bold text-gray-900 mb-3">
                        Código de Empresa Requerido
                    </h1>
                    
                    <p className="text-gray-600 mb-6">
                        Para acceder a CompilaTime, debes ingresar el código de tu empresa. 
                        Contacta al administrador de tu empresa si no tienes el código.
                    </p>
                    
                    <div className="bg-gray-50 rounded-lg p-4 mb-6">
                        <p className="text-sm text-gray-700 mb-2">
                            La URL debe tener el formato:
                        </p>
                        <code className="block bg-white px-3 py-2 rounded text-sm text-primary-600 border border-gray-200">
                            https://app.compilatime.es/XXXXXXX/portal/login
                        </code>
                        <p className="text-sm text-gray-500 mt-2">
                            (donde XXXXXXX es el código de tu empresa)
                        </p>
                    </div>
                    
                    <Link
                        to="/"
                        className="inline-block w-full text-center bg-primary-600 text-white px-4 py-3 rounded-lg hover:bg-primary-700 transition-colors font-medium"
                    >
                        Volver al inicio
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CompanyRequiredPage;
